const U = (id, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;
const P = (id, w = 1600) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
const A = (id) => `https://customer-assets-wrfwihn1.emergentagent.net/job_custom-cabinetry-gta/artifacts/${id}`;

// Real Hive Interior project photos
export const REAL = {
  kitchenGrey: A("p0o41jhz_IMG-20241125-WA0008.jpg"),
  kitchenIsland: A("pmge43st_IMG-20241125-WA0006.jpg"),
  builtInWall: A("h26ugqgf_WhatsApp%20Image%202025-02-03%20at%2020.40.29_d048c44b.webp"),
  installKitchen: A("g16u9x31_WhatsApp%20Image%202025-01-31%20at%2012.37.22_ca524e8c.webp"),
  installWardrobe: A("01s2pxqo_WhatsApp%20Image%202025-01-31%20at%2012.44.39_9e4aef70.webp"),
};

export const SITE = {
  name: "Hive Interiors",
  tagline: "Custom Cabinets. Complete Renovations. Beautiful Interiors.",
  phone: "(647) 222-0742",
  phoneHref: "tel:+16472220742",
  email: "hello@hiveinteriors.ca",
  owner: "Chandi Binduhewa",
  ownerTitle: "Director",
  address: "1370 Birchmount Rd, Unit 5, Scarborough, ON M1P 2E9",
  website: "www.hiveinteriors.ca",
  region: "Greater Toronto Area",
  description:
    "Hive Interiors specializes in custom kitchen cabinets, kitchen & bathroom renovations, and complete home interior solutions across the GTA. We combine modern design, smart functionality, and quality craftsmanship to create beautiful, customized spaces built to last.",
  socials: [],
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "Kitchens", href: "/kitchens" },
  { label: "Bathrooms", href: "/bathrooms" },
  { label: "Interiors", href: "/interiors" },
  { label: "Projects", href: "/projects" },
  { label: "About Us", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export const IMAGES = {
  hero: P(18285887, 1920),
  kitchenHero: U("photo-1600489000022-c2086d79f9d4", 1920),
  bathHero: U("photo-1600566752355-35792bedcfea", 1920),
  interiorHero: U("photo-1600585154340-be6161a56a0c", 1920),
  aboutHero: U("photo-1615873968403-89e068629265", 1920),
  projectsHero: U("photo-1600210492486-724fe5c67fb0", 1920),
  servicesHero: U("photo-1600607687939-ce8a6c25118c", 1920),
  contactSide: U("photo-1618221195710-dd6b41faaea6", 1200),
  cta: U("photo-1600566753086-00f18fb6b3ea", 1920),
};

export const SERVICES = [
  {
    num: "01",
    title: "Custom Kitchen Cabinets",
    desc: "Made-to-measure cabinetry designed for your space, style, and storage needs.",
    img: REAL.kitchenGrey,
    alt: "Custom grey kitchen cabinets with brass hardware built by Hive Interior",
    href: "/kitchens",
  },
  {
    num: "02",
    title: "Kitchen Renovations",
    desc: "Complete kitchen transformations from design through installation.",
    img: P(7587864),
    alt: "Complete kitchen renovation with sleek granite island",
    href: "/kitchens",
  },
  {
    num: "03",
    title: "Bathroom Renovations",
    desc: "Modern, functional bathrooms designed with quality materials and attention to detail.",
    img: P(8082223),
    alt: "Luxury bathroom renovation with marble walls",
    href: "/bathrooms",
  },
  {
    num: "04",
    title: "Cabinet Refacing",
    desc: "Give your existing kitchen a fresh new look without replacing the entire cabinetry.",
    img: U("photo-1556912167-f556f1f39fdf"),
    alt: "Refaced kitchen cabinets with a fresh modern finish",
    href: "/kitchens",
  },
  {
    num: "05",
    title: "Home Interior Renovations",
    desc: "Transform living spaces with thoughtful design, quality finishes, and professional workmanship.",
    img: U("photo-1600607687939-ce8a6c25118c"),
    alt: "Full home interior renovation with modern finishes",
    href: "/interiors",
  },
  {
    num: "06",
    title: "Custom Interior Solutions",
    desc: "Vanities, closets, built-ins, storage solutions, and other customized interior projects.",
    img: U("photo-1595428774223-ef52624120d2"),
    alt: "Custom closet and built-in storage solution",
    href: "/interiors",
  },
];

export const WHY_POINTS = [
  { title: "Custom-Designed Solutions", desc: "Every project is designed around your space, your lifestyle, and your vision — never off the shelf." },
  { title: "Modern & Timeless Designs", desc: "Interiors that feel current today and still beautiful a decade from now." },
  { title: "Quality Craftsmanship", desc: "Precise joinery, durable materials, and finishes built to last." },
  { title: "Smart Storage Solutions", desc: "Cabinetry engineered to make every inch of your home work harder." },
  { title: "Attention to Detail", desc: "From hardware to reveals, the small things are what make a space feel premium." },
  { title: "Professional Installation", desc: "Clean, careful, and respectful installation by experienced tradespeople." },
  { title: "End-to-End Project Support", desc: "One team guiding you from first consultation to final walkthrough." },
  { title: "Serving the GTA", desc: "Proudly working with homeowners across Toronto and the surrounding communities." },
];

export const PROJECTS = [
  { title: "Modern Kitchen", cat: "Kitchens", img: U("photo-1556911220-bff31c812dba"), alt: "Modern kitchen with flat-panel cabinetry" },
  { title: "Custom Kitchen", cat: "Kitchens", img: REAL.kitchenGrey, alt: "Custom grey shaker kitchen cabinets with brass hardware by Hive Interior" },
  { title: "Kitchen Renovation", cat: "Renovations", img: REAL.kitchenIsland, alt: "Renovated kitchen island with farmhouse sink and brass faucet by Hive Interior" },
  { title: "Bathroom", cat: "Bathrooms", img: U("photo-1620626011761-996317b8d101"), alt: "Renovated bathroom with modern fixtures" },
  { title: "Custom Vanity", cat: "Vanities", img: U("photo-1584622650111-993a426fbf0a"), alt: "Custom bathroom vanity with storage" },
  { title: "Closet", cat: "Storage", img: U("photo-1558997519-83ea9252edf8"), alt: "Custom walk-in closet and wardrobe storage" },
  { title: "Built-Ins", cat: "Built-Ins", img: REAL.builtInWall, alt: "Custom built-in entertainment wall unit with shelving by Hive Interior" },
  { title: "Full Home Interior", cat: "Interiors", img: U("photo-1618221195710-dd6b41faaea6"), alt: "Complete home interior transformation" },
];

export const PROCESS_STEPS = [
  { num: "1", title: "Consultation", desc: "We discuss your needs, ideas, budget, and vision for the space." },
  { num: "2", title: "Design", desc: "We create a customized design tailored to your space and lifestyle." },
  { num: "3", title: "Selection", desc: "Choose finishes, colours, materials, hardware, and accessories with our guidance." },
  { num: "4", title: "Installation", desc: "Professional installation carried out with care and attention to detail." },
  { num: "5", title: "Completion", desc: "A finished space designed to look beautiful and work for your lifestyle." },
];

export const SERVICE_AREAS = [
  "Scarborough", "Toronto", "Pickering", "Ajax", "Whitby", "Oshawa", "Markham",
  "Richmond Hill", "Vaughan", "North York", "Mississauga", "Brampton", "Etobicoke",
  "Oakville", "and surrounding GTA communities",
];

export const PROJECT_TYPES = [
  "Custom Kitchen Cabinets",
  "Kitchen Renovation",
  "Bathroom Renovation",
  "Cabinet Refacing",
  "Home Interior Renovation",
  "Custom Interior Solution",
  "Other",
];

export const BUDGETS = [
  "Under $10,000",
  "$10,000 – $25,000",
  "$25,000 – $50,000",
  "$50,000 – $100,000",
  "$100,000+",
  "Not sure yet",
];
